import styled from "styled-components";
import {mediaTablet, mediaLaptop, mediaUnderLaptop} from "src/styles/mediaQuery";
import imgServiceLogo from 'src/assets/images/logo.png';
import imgServiceLogoWt from 'src/assets/images/logo-wt.svg';
import imgGooglePlay from 'src/assets/images/img_googleplay.png';
import imgAppStore from 'src/assets/images/img_app_store.png';
import {Link, NavLink} from "react-router-dom";
import {Noto_SubHeading2_b16, Noto_SubHeading2_r16} from "src/styles/font/NotoSansKrFonts";
import {HeaderProps} from "src/components/layout/Header/index";


function HeaderView({
                        dropdownButtonRef,
                        dropdownMenuRef,
                        onDropdownToggle,
                        onMenuItemClick,
                        $isDarkMode,
                        currentSection,
                        buttonLabel,
                        onLogoClick,
                        onMovePartnerSection,
                        onMoveEventSection,
                    }: HeaderProps ) {
    return (
        <HeaderWrap $isDarkMode={$isDarkMode} currentSection={currentSection}>
            <HeaderWrapInner>
                <ServiceLogo $isDarkMode={$isDarkMode} onClick={onLogoClick} currentSection={currentSection} tabIndex={0}/>
                <HeaderNav>
                    <NavContainer>
                        <NavList>
                            <NavItem>
                                <NavLinkStyled to="/"  $isDarkMode={$isDarkMode} $isActive={currentSection === 'eventSection'} onClick={onMoveEventSection} >서비스 소개</NavLinkStyled>
                            </NavItem>
                            <NavItem>
                                <NavLinkStyled to="/"  $isDarkMode={$isDarkMode} $isActive={currentSection === 'partnerSection'} onClick={onMovePartnerSection}  >제휴 문의</NavLinkStyled>
                            </NavItem>
                        </NavList>
                    </NavContainer>
                    <Dropdown>
                        <DropdownButton
                            ref={dropdownButtonRef}
                            onClick={onDropdownToggle}
                            aria-expanded="false"
                            aria-haspopup="true"
                        >
                            {buttonLabel}
                        </DropdownButton>
                        <DropdownMenu ref={dropdownMenuRef} role="menu" $isDarkMode={$isDarkMode} currentSection={currentSection}>
                            <DropdownItem onClick={onMenuItemClick} $isDarkMode={$isDarkMode} currentSection={currentSection} className="google-play">
                                <NavLink to={'https://play.google.com/store/apps/details?id=com.datau.eventu'} target="_blank" role="menuitem">구글플레이</NavLink>
                            </DropdownItem>
                            <DropdownItem $isDarkMode={$isDarkMode} currentSection={currentSection} className="app-store">
                                <NavLink   to={'https://itunes.apple.com/kr/app/id6602889410'} target="_blank" role="menuitem">앱스토어</NavLink>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </HeaderNav>
            </HeaderWrapInner>
        </HeaderWrap>
    );
}

export default HeaderView;


const HeaderWrap = styled.header<{ $isDarkMode: boolean;currentSection: string }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 100%;
  z-index: 10;
  transition: background-color 0.3s ease;
  background-color: transparent;
  ${mediaTablet} {
    background-color: ${({ $isDarkMode, currentSection }) =>
            currentSection === 'partnerSection'
                    ? ($isDarkMode ? 'var(--white)' : 'var(--white)') 
                    : ($isDarkMode ? 'var(--black-95)' : 'var(--white)')};
  }
`;

const HeaderWrapInner = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100px;
  max-width: 1460px;
  margin: 0 auto;
  padding: 24px 0;
  ${mediaUnderLaptop} {
    transform: scale(.85);
  }
  ${mediaTablet} {
    padding: 8px 20px;
    height: 50px;
  }
`;

const ServiceLogo = styled.div<{ $isDarkMode: boolean; currentSection: string }>`
  width: 131px;
  height: 24px;
  background: ${({ $isDarkMode }) => $isDarkMode ? `url(${imgServiceLogoWt})` : `url(${imgServiceLogo})`} no-repeat center;
  background-size: contain;
  cursor: pointer;
  ${mediaTablet} {
    width: 90px;
    height: 17px;
    background: ${({ $isDarkMode, currentSection }) =>
            currentSection === 'partnerSection'
                    ? ($isDarkMode ?  `url(${imgServiceLogo})` :  `url(${imgServiceLogo})`)
                    : ($isDarkMode ? `url(${imgServiceLogoWt})` : `url(${imgServiceLogo})`)} no-repeat center;
    background-size: contain;
  }
 
`;

const HeaderNav = styled.nav`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 30px;
`;

const NavContainer = styled.div`
  ${mediaTablet} {
    display: none;
  }
`;

const NavList = styled.ul`
  display: flex;
  flex-flow: row nowrap;
  gap: 30px;
`;

const NavItem = styled.li``;


const NavLinkStyled = styled(Link)<{ $isDarkMode: boolean; $isActive: boolean;}>`
  ${Noto_SubHeading2_r16};
  padding: 10px 30px;
  color: ${({ $isActive, $isDarkMode }) =>
          $isActive
                  ? $isDarkMode
                          ? 'var(--white)'
                          : 'var(--point-color-1)'
                  : 'var(--black-50)'
  };
 
  &:hover,
  &:focus-visible {
    color: ${({ $isDarkMode }) => $isDarkMode ? 'var(--white)' : 'var(--black)'};
  }

  &:active {
    color: ${({ $isDarkMode }) => $isDarkMode ? 'var(--white)' : 'var(--point-color-1)'};
  }
`


const Dropdown = styled.div`
  position: relative;
`;

const DropdownButton = styled.button`
  ${Noto_SubHeading2_b16};
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 100%;
  height: 44px;
  padding: 0 30px;
  background-color: var(--point-color-1);
  border-radius: 10px;
  color: var(--white);

  ${mediaLaptop} {
    height: 34px;
    line-height: 34px;
    padding: 10px 18px;
    border-radius: 8px;
  }

  ${mediaTablet} {
    font-size: 14px;
  }
`;

const DropdownMenu = styled.ul<{ $isDarkMode: boolean;currentSection: string }>`
  position: absolute;
  visibility: hidden;
  opacity: 0;
  transform: translateY(-10px);
  max-height: 0;
  transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease, visibility 0s 0.3s;
  overflow: hidden;
  width: 100%;
  background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(26, 26, 26, 0.5)' : 'rgb(255, 255, 255)'};
  backdrop-filter: ${({ $isDarkMode }) => $isDarkMode ? 'blur(10px)' : 'none'};
  top: 48px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
 
  ${mediaLaptop} {
    width: 118px;
    right: 0;
    top: 38px;
  }

 ${mediaTablet} {
    width: 106px;
   background-color: ${({ $isDarkMode, currentSection }) =>
           currentSection === 'partnerSection'
                   ? ($isDarkMode ? 'rgb(255, 255, 255)' : 'rgb(255, 255, 255)')
                   : ($isDarkMode ? 'rgba(26, 26, 26, 0.5)' : 'rgb(255, 255, 255)')};
  }

  &.show {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
    max-height: 200px;
    transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease;
  }
`;

const DropdownItem = styled.li<{ $isDarkMode: boolean;currentSection:string; }>`
  position: relative;
  display: flex;
  width: 100%;
  padding: 14px 16px;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-family: NotoSansRegular, sans-serif;
  font-size: 16px;
  line-height: normal;
  flex-shrink: 0;
  color:${({ $isDarkMode }) => $isDarkMode ? 'var(--white)' : 'var(--black)'};
  @media (hover: hover) and (pointer: fine) {
    &:hover{
      color:${({ $isDarkMode }) => $isDarkMode ? 'var(--white)' : 'var(--point-color-1)'};
      background:${({ $isDarkMode }) => $isDarkMode ? 'var(--black-40)' : 'unset'};
      transition:.3s ease-in-out;
    }
  }
  ${mediaLaptop} {
    gap: 6px;
    padding: 12px 10px;
  }

 ${mediaTablet} {
    font-size: 14px;
   color: ${({ $isDarkMode, currentSection }) =>
           currentSection === 'partnerSection'
                   ? ($isDarkMode ? 'var(--black)' : 'var(--black)')
                   : ($isDarkMode ? 'var(--white)' : 'var(--black)')};
  }

  &:nth-child(1) {
    border-bottom: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'var(--black-90)' : 'var(--black-6)'};
    ${mediaTablet} {
      border-bottom: 1px solid ${({ $isDarkMode, currentSection }) =>
              currentSection === 'partnerSection'
                      ? ($isDarkMode ? 'var(--black-6)' : 'var(--black-6)')
                      : ($isDarkMode ? 'var(--black-90)' : 'var(--black-6)')};
    }
  }

  &.google-play::before,
  &.app-store::before {
    flex-shrink: 0;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  &.google-play::before {
    background: url(${imgGooglePlay}) no-repeat center/cover;
  }

  &.app-store::before {
    background: url(${imgAppStore})no-repeat center/cover;
  }
`;
